export default "__VITE_ASSET__CEv0l5Ji__"